<div
  class="nav-menu-container"
  [class.open]="(navOpen$ | async) === true"
  [class.inline]="inline"
  [class.analyst-studio]="isAnalystStudio$ | async"
>
  <capra-logo-button
    class="nav-logo"
    [hamburgerState]="(navOpen$ | async) === true ? 'expanded' : undefined"
    theme="light"
    (clicked)="closeNavMenu()"
  ></capra-logo-button>
  <div class="nav-content">
    <mode-nav-account-menu
      [currentOrg]="currentOrg$ | async"
      [currentUser]="currentUser$ | async"
    ></mode-nav-account-menu>
    <div class="static-nav">
      <mode-nav-home-links
        [currentOrg]="currentOrg$ | async"
        [personalCollectionToken]="personalCollectionToken$ | async"
        [target]="target"
      ></mode-nav-home-links>
    </div>
    <div *ngIf="isAnalystStudio$ | async" class="nav-divider"></div>
    <div class="scroll-nav">
      <mode-nav-collections
        [target]="target"
        [currentOrg]="currentOrg$ | async"
        [collections]="collections$ | async"
        [isCollectionsLoading]="collectionsLoading$ | async"
      >
      </mode-nav-collections>
      <div *ngIf="isAnalystStudio$ | async" class="nav-divider"></div>
      <mode-nav-definitions
        [target]="target"
        [currentOrg]="currentOrg$ | async"
        [datasources]="datasources$ | async"
        [isDatasourcesLoading]="datasourcesLoading$ | async"
      ></mode-nav-definitions>
    </div>
  </div>
</div>
<div
  class="nav-menu-mask"
  [class.open]="(navOpen$ | async) === true"
  [class.inline]="inline"
  (click)="closeNavMenu()"
></div>
